var map = {
	"./icons/dashboard": "9f1d",
	"./icons/dashboard.vue": "9f1d",
	"./img/404.svg": "8e71",
	"./img/iconNew.png": "5755",
	"./img/logo.png": "4ffd",
	"./img/logoBlue.png": "1741",
	"./img/logoMini.png": "22c4",
	"./img/logoNew.png": "950d",
	"./img/myClass.jpg": "82a4",
	"./img/qr.jpg": "71f3",
	"./img/sidebarNew.png": "0cea",
	"./img/uni.png": "d424",
	"./img/uni2.jpg": "52f0",
	"./styles/main.scss": "2fb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";